export const titleMap: Record<string, string> = {
  submitted: 'Orders to Accept',
  draft: 'Active Carts',
  accepted: 'Fulfil Orders',
  orders: 'Orders Dashboard',
};
